import { render, staticRenderFns } from "./PaymentChannelTables.vue?vue&type=template&id=cd385964&"
import script from "./PaymentChannelTables.vue?vue&type=script&lang=js&"
export * from "./PaymentChannelTables.vue?vue&type=script&lang=js&"
import style0 from "./PaymentChannelTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports